// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1MsFG","label":"Labeled_label__2Yzum","divider":"Labeled_divider__I4tzF"};